/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonTariff,
    JsonTariffFromJSON,
    JsonTariffFromJSONTyped,
    JsonTariffToJSON,
} from './JsonTariff';

/**
 * 
 * @export
 * @interface ApiResultOfJsonTariff
 */
export interface ApiResultOfJsonTariff {
    /**
     * 
     * @type {JsonTariff}
     * @memberof ApiResultOfJsonTariff
     */
    data?: JsonTariff;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonTariff
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonTariff
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonTariff
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonTariff
     */
    result?: ApiResultOfJsonTariffResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonTariffResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonTariffFromJSON(json: any): ApiResultOfJsonTariff {
    return ApiResultOfJsonTariffFromJSONTyped(json, false);
}

export function ApiResultOfJsonTariffFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonTariff {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonTariffFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonTariffToJSON(value?: ApiResultOfJsonTariff | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonTariffToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

